import React, { useEffect, useState } from "react";
import {getReadableTime } from "../../utils/converter";
import Loading from "../common/loading";

const VitalTable = ({ selectedDate, data, babyAge }) => {
  //console.log(data)

  const [processedData, setProcessedData] = useState([]);
  const [loading, setLoading] = useState(false);

  const processData = (data) => {
    setLoading(true);
  
    const paramKeys = ["spo2","rr" ,"temp", "hrv", "pulse", "hr"];
    const timestampSet = new Set();
  
    const paramValues = {};
  
    paramKeys.forEach((param) => {
      paramValues[param] = {};
    });
  
    // Assuming data is an array with one object as per screenshot
    const vitals = data[0];
  
    paramKeys.forEach((param) => {
      if (vitals[param] && Array.isArray(vitals[param])) {
        vitals[param].forEach((entry) => {
          Object.entries(entry).forEach(([timestamp, value]) => {
            paramValues[param][timestamp] = parseFloat(value);
            timestampSet.add(timestamp);
          });
        });
      }
    });
  
    const sortedTimestamps = Array.from(timestampSet).sort();
  
    const formattedData = sortedTimestamps.map((timestamp) => {
      const row = { data_time: parseInt(timestamp), params: {} };
  
      paramKeys.forEach((param) => {
        const value = paramValues[param][timestamp];
        row.params[param] =
          typeof value === "number" && !isNaN(value) && value !== -1
            ? parseFloat(value.toFixed(2))
            : "--";
      });
  
      return row;
    });
  
    setLoading(false);
    return formattedData;
  };

  const getVitalRange = (ageInMonths) => {
    switch (true) {
      case ageInMonths <= 12: 
        return { rr: [25, 60], hr: [110, 180], spo2:[90,100], pulse:[110,180]};
      case ageInMonths >= 13 && ageInMonths <= 24:
        return { rr: [20, 50], hr: [100, 170], spo2:[92,100], pulse:[100,170]};
      case ageInMonths >= 25 && ageInMonths <= 59: 
        return { rr: [18, 40], hr: [90, 160], spo2:[92,100], pulse:[90,160]};
      case ageInMonths >= 60 && ageInMonths <= 119:
        return { rr: [17, 30], hr: [70, 140], spo2:[92,100], pulse:[70,140]};
      case  ageInMonths >= 120 && ageInMonths <= 179: 
        return { rr: [14, 25], hr: [60, 120], spo2:[92,100], pulse:[60,120]};
      case ageInMonths >=180: 
        return { rr: [12, 18], hr: [60, 100], spo2:[94,100], pulse:[60,100]};
    }
  };

  useEffect(() => {
    if(data.length > 0 && data != undefined){
      setProcessedData(processData(data));
    }
  }, [data]);

  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, 
    });
  };

  const renderParamCell = (param, value, ageInMonths) => {
    const vitalRanges = getVitalRange(ageInMonths);
  
    const [min, max] = vitalRanges[param] || [];
  
    const isOutOfRange = value !== "--" && (value < min || value > max);
  
    const displayValue = param === "spo2" && value !== "--" ? `${value}%` : value;
  
    return (
      <td className={`table-text ${isOutOfRange ? "out-of-range" : ""}`}>
        {displayValue}
      </td>
    );
  };

  return (
    <>
      {loading ? 
          (
            <div className='loading-div'><Loading /></div>
          ) 
        : 
        (
          <div style={{paddingBottom: "6rem", marginBottom: "2rem", marginTop: "2rem",}} >
            <table style={{ width: "90%", paddingLeft: "1rem", paddingRight: "1rem", marginLeft: "2.5rem", marginRight: "2rem", paddingBottom: "2rem",borderCollapse: "collapse",}} >
              <thead>
                <tr className="vital-table-layout header">
                  <td className="navam-header-text">Time</td>
                  <td className="navam-header-text">Heart Rate</td>
                  <td className="navam-header-text">SpO2</td>
                  <td className="navam-header-text">Pulse Rate</td>
                  <td className="navam-header-text">RR</td>
                  <td className="navam-header-text">HRV</td>
                  <td className="navam-header-text">Temp</td>
                </tr>
              </thead>

              <tbody>
                {processedData.map((row, index) => (
                  <tr key={index} className="vital-table-value-layout">
                    <td className="table-text"> 
                      {(formatTime(row.data_time))}
                    </td>
                    {renderParamCell("hr", row.params.hr, babyAge)}
                    {renderParamCell("spo2", row.params.spo2, babyAge)}
                    {renderParamCell("pulse", row.params.pulse, babyAge)}
                    {renderParamCell("rr", row.params.rr, babyAge)}
                    {renderParamCell("hrv", row.params.hrv, babyAge)}
                    {renderParamCell("temp", row.params.temp, babyAge)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      }
    </>
  );
};

export default VitalTable;
